/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignScheduleUpdate } from '../../axios/campaignScheduleUpdate'
import type {
	CampaignScheduleUpdateError,
	CampaignScheduleUpdatePathParams,
	CampaignScheduleUpdateRequest,
	CampaignScheduleUpdateResponse,
} from '../../types/CampaignScheduleUpdate'

export const campaignScheduleUpdateMutationKey = () => [{ url: '/campaigns/:campaign/schedule' }] as const

export type CampaignScheduleUpdateMutationKey = ReturnType<typeof campaignScheduleUpdateMutationKey>

export type CampaignScheduleUpdateVariables = {
	campaign: CampaignScheduleUpdatePathParams['campaign']
	data: CampaignScheduleUpdateRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignScheduleController.php CampaignScheduleController::update */
export function useCampaignScheduleUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignScheduleUpdateResponse,
		AxiosError<CampaignScheduleUpdateError>,
		CampaignScheduleUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignScheduleUpdateMutationKey(),
		mutationFn: ({ campaign, data }: CampaignScheduleUpdateVariables) =>
			campaignScheduleUpdate(campaign, data, config).then(res => res.data),
		...options,
	})
}
